import { IChatV2Schema } from '@cian/chats-api';

import { IErrorResponseSchema } from '../../repositories/chats/entities/schemas/ErrorResponseSchema';
import {
  fetchChatsMarkAsStarred,
  TChatsMarkAsStarredRequest,
  TChatsMarkAsStarredResponse,
} from '../../repositories/chats/v1/chats/mark-as-starred';
import { showAlert } from '../../slices/alertSlice';
import { EAlert } from '../../types/alert';
import { TThunkAction } from '../../types/redux/thunk';
import { ETelemetryEvents } from '../../types/telemetry';
import { deselectAllChats, toggleChatListPending, updatedFromServer } from '../chatList/actions';

/**
 * Пометить чат как важный
 * @param parameters.chatId id чата
 */
export const markChatAsStarred =
  (parameters: TChatsMarkAsStarredRequest): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const { httpApi, logger, telemetry } = context;

    dispatch(toggleChatListPending(true));

    try {
      const { statusCode, response }: TChatsMarkAsStarredResponse = await fetchChatsMarkAsStarred({
        httpApi,
        config: { requestConfig: { withCredentials: true } },
        parameters: { chatId: parameters.chatId },
      });

      if (statusCode === 200 && response.chat) {
        const chat = response.chat as unknown as IChatV2Schema;

        dispatch(updatedFromServer(chat));
        telemetry.increment(ETelemetryEvents.MarkMessagesAsStarredSuccess);
        dispatch(deselectAllChats());

        /**
         * При успешном помечании чата как важного, показываем алерт
         */
        dispatch(showAlert({ type: EAlert.Info, message: 'Чат добавлен в важные' }));
      } else {
        const { message } = (response as IErrorResponseSchema) || {};
        const errors = (response as IErrorResponseSchema)?.errors;
        telemetry.increment(ETelemetryEvents.MarkMessagesAsStarredFail);
        logger.warning('Код ответа не 200', {
          message: 'Не удалось чат добавить в важные',
          domain: 'src/shared/actions/chatList/markChatAsStarred.ts',
          statusCode,
          messsage: message || 'Неизвестная ошибка',
          errors: JSON.stringify(errors),
        });

        dispatch(showAlert({ message: 'Не удалось чат добавить в важные' }));
      }
    } catch (ex) {
      telemetry.increment(ETelemetryEvents.MarkMessagesAsStarredFail);
      logger.error(ex, {
        message: 'Не удалось чат добавить в важные',
        domain: 'src/shared/actions/chatList/markChatAsStarred.ts',
      });

      dispatch(showAlert({ message: 'Не удалось чат добавить в важные' }));
    } finally {
      dispatch(toggleChatListPending(false));
    }
  };
